<template>
  <CDataTable
    :class="classToSet"
    :striped="true"
    :items="itemsComputed"
    :fields="fields"
    :itemsPerPage="itemsPerPage"
    :pagination="pagination && items.length >= itemsPerPage"
    :sorter="sorter"
    :table-filter="tableFilter"
    :loading="loading"
    :active-page="activePage"
    hover
    :responsive="true">

    <template #edit="{item}">
      <td class="py-2 text-center">
        <CButton
          color="warning"
          variant="outline"
          square
          size="sm"
          @click="edit(item)">
          Edit
        </CButton>
      </td>
    </template>

    <template #remove="{item}">
      <td class="py-2 text-center">
        <CButton
          color="danger"
          variant="outline"
          square
          size="sm"
          @click="remove(item)">
          Remove
        </CButton>
      </td>
    </template>

    <template #loading>
      <div></div>
    </template>

    <template #no-items-view v-if="loading">
      <div class="loading-container">
        <i class="fa fa-cog fa-spin fa-3x"></i>
      </div>
    </template>

  </CDataTable>
</template>

<script>
  export default {
    name: 'port-table',

    props: {
      items: {
        type: Array
      },
      itemsPerPage: {
        type: Number,
        default: 50
      },
      pagination: {
        type: Boolean,
        default: true,
      },
      activePage: {
        type: Number,
        default: null,
      },
      fields: {
        type: Array
      },
      classToSet: {
        type: String,
        default: ''
      },
      templateToShow: {
        type: String
      },
      sorter: {
        type: [Boolean, Object],
        default: true,
      },
      tableFilter: {
        type: [Boolean, Object],
        default: false,
      },
      loading: {
        type: Boolean,
      },
    },

    methods: {
      edit(item) {
        this.$emit('edit', item)
      },

      remove(item) {
        this.$emit('remove', item)
      },
    },

    computed: {
      fieldNames() {
        return this.fields.map(field => {
          return field.key || field;
        });
      },

      itemsComputed() {
        const fieldNames = this.fieldNames;
        const defaultValue = '--';

        return this.items.map(item => {
          fieldNames.forEach(fieldName => {
            item[fieldName] = item[fieldName] || defaultValue;
          });
          return item;
        });
      },
    },
  }
</script>

<style>
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    color: #9d9d9d;
    background-color: #f6f6f680;
  }


  .permission {
    padding-top: 2px;
    padding-right: 3px;
    padding-bottom: 2px;
    padding-left: 3px;
    color: rgb(46, 44, 44);
    background: lightgray;
    font-weight: bold;
  }
</style>